import React from 'react';
import ButtonV1 from '../ButtonV1';
import Styles from './styles.js';

export default function RentalMontReal({ imgSrc, title, locNone, loc, para1, para2, btn_text, link }) {
  return (
    <>
      <div className="py-14">
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-x-12 ">
          <div className=" lg:pb-12 pb-6 relative ">
            <img className="lg:h-4/5 h-full w-full" src={`${imgSrc}`} alt="" />
          </div>
          <div className="  lg:pb-12 pb-0">
            <div className="pt-6 lg:pb-6 pb-0">
              <h1 className={`montreal-head-title uppercase`}>{title}</h1>
              <p className={`montreal-head-para py-2 ${locNone}`}>{loc}</p>
              <p className="montreal-head-para">{para1}</p>
              <p className="montreal-head-para">{para2}</p>
              <ButtonV1
                btnHref={link}
                btnName={btn_text}
                px="px-8"
                py="py-3"
                txtColor="rgb(1, 1, 1)"
                mdWidth="auto"
                acWidth="full"
                justify="center"
              />
            </div>
          </div>
        </div>
      </div>
      <hr className="lg:hidden block" />
      <Styles />
    </>
  );
}
